import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ManOutlinedSvg from "@ant-design/icons-svg/es/asn/ManOutlined";
import AntdIcon from "../components/AntdIcon";
var ManOutlined = function ManOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ManOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ManOutlined.displayName = 'ManOutlined';
}
export default /*#__PURE__*/React.forwardRef(ManOutlined);